import Rollbar from 'rollbar';

export class Logger {
    private client: Rollbar;
    public static FAILED_MESSAGE = 'failed to parse message';

    public constructor() {
        this.client = new Rollbar({
            accessToken: process.env.REACT_APP_ROLLBAR_ACCESSS_TOKEN,
            captureUncaught: true,
            captureUnhandledRejections: true,
            environment: process.env.REACT_APP_STAGE || 'development'
        });
        this.handleWebRtcErrors();
    }

    public error(...errors: Rollbar.LogArgument[]) {
        if (process.env.REACT_APP_STAGE === 'production'
            && this.parsableMessage(...errors).length
        ) {
            this.client.error(...errors);
        }
    }

    private handleWebRtcErrors(): void {
        if ('tsk_utils_log_error' in window) {
            const originalErrorLog = window.tsk_utils_log_error;
            window.tsk_utils_log_error = (error: string) => {
                this.error(error);

                if (originalErrorLog) {
                    originalErrorLog(error);
                }
            }
        }
    }

    private parsableMessage(...errors: Rollbar.LogArgument[]): Rollbar.LogArgument[] {
        return errors.filter((error): boolean => {
            const message = error.toString();

            return message.toLowerCase().indexOf(Logger.FAILED_MESSAGE) === -1;
        })
    }
}
